import { apiRequest } from './apiClient';

export function fetchPaymentMode(): Promise<{ testMode: boolean }> {
  return apiRequest<{ testMode: boolean }>('/api/payments/mode');
}

export interface KakaoReadyResult {
  redirectUrl: string;
}

export function startKakaoPayment(orderNo: string): Promise<KakaoReadyResult> {
  return apiRequest<KakaoReadyResult>('/api/payments/kakao/ready', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ orderNo }),
  });
}

export interface NaverReadyResult {
  mode: 'development' | 'production';
  clientId: string;
  chainId?: string;
  payParams: NaverPayOpenParams;
}

export function startNaverPayment(orderNo: string): Promise<NaverReadyResult> {
  return apiRequest<NaverReadyResult>('/api/payments/naver/ready', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ orderNo }),
  });
}
